import { useId, useState } from 'react';
import SeccionFuentes from './newsletter/SeccionFuentes';
import SeccionEdiciones from './newsletter/SeccionEdiciones';
import SeccionAjustes from './newsletter/SeccionAjustes';
import SeccionEntrenamiento from './newsletter/SeccionEntrenamiento';

type Tab = 'ediciones' | 'fuentes' | 'entrenamiento' | 'ajustes';

const TABS: { id: Tab; label: string }[] = [
  { id: 'ediciones', label: 'Ediciones' },
  { id: 'fuentes', label: 'Fuentes' },
  { id: 'entrenamiento', label: 'Entrenamiento' },
  { id: 'ajustes', label: 'Ajustes' },
];

export default function Newsletter() {
  const [tab, setTab] = useState<Tab>('ediciones');
  const baseId = useId();

  return (
    <div className="flex flex-col gap-6">
      <div
        role="tablist"
        aria-label="Áreas del newsletter"
        className="flex flex-wrap gap-1 border-b border-slate-200"
      >
        {TABS.map((t) => {
          const activo = tab === t.id;
          return (
            <button
              key={t.id}
              id={`${baseId}-${t.id}`}
              role="tab"
              type="button"
              aria-selected={activo}
              aria-controls={`${baseId}-${t.id}-panel`}
              onClick={() => setTab(t.id)}
              className={`-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-azul-profundo ${
                activo
                  ? 'border-azul-profundo text-azul-profundo'
                  : 'border-transparent text-gris hover:text-azul-profundo'
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div id={`${baseId}-${tab}-panel`} role="tabpanel" aria-labelledby={`${baseId}-${tab}`}>
        {tab === 'ediciones' && <SeccionEdiciones />}
        {tab === 'fuentes' && <SeccionFuentes />}
        {tab === 'entrenamiento' && <SeccionEntrenamiento />}
        {tab === 'ajustes' && <SeccionAjustes />}
      </div>
    </div>
  );
}
